// ══════════════════════════════════════════════════════════════
// Centros de Apoyo — Module JS
// ══════════════════════════════════════════════════════════════
let _caData = [];
let _caUsers = [];
window._caDetalleId = null;
const _caMoneyFmt = (v,m)=>(m==='USD'?'$':'$')+(Number(v)||0).toLocaleString('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2})+(m==='USD'?' USD':'');
const _caEstadoBadge = s=>({
    activo:'<span style="color:#22c55e;">🟢 Activo</span>',
    suspendido:'<span style="color:#f59e0b;">🟡 Suspendido</span>',
    cerrado:'<span style="color:#ef4444;">🔴 Cerrado</span>',
    por_asignar:'<span style="background:rgba(99,102,241,.15);color:#a5b4fc;padding:2px 8px;border-radius:12px;font-size:.72rem;font-weight:600;">🏷️ Por Asignar</span>'
}[s]||s);

async function _caSql(sqlStr){
    try{
        const j=await BO_API.post('/bo/sql-relay',{secret:'duletia_relay_2026',sql:sqlStr});
        if(j && j.error) throw new Error(typeof j.error==='string'?j.error:JSON.stringify(j.error));
        return j.rows||j.result||(Array.isArray(j)?j:[]);
    }catch(e){
        console.error('_caSql error:',e.message,'| SQL:',sqlStr.substring(0,200));
        throw e;
    }
}

// ── Auto-migration: add fiscal columns if missing ─────────────
(async function _caMigrate(){
    try{ await _caSql(`ALTER TABLE centro_apoyo ADD COLUMN IF NOT EXISTS rfc VARCHAR(20)`); }catch(e){}
    try{ await _caSql(`ALTER TABLE centro_apoyo ADD COLUMN IF NOT EXISTS razon_social VARCHAR(255)`); }catch(e){}
    try{ await _caSql(`ALTER TABLE centro_apoyo ADD COLUMN IF NOT EXISTS codigo_postal VARCHAR(10)`); }catch(e){}
    try{ await _caSql(`ALTER TABLE centro_apoyo ADD COLUMN IF NOT EXISTS regimen_fiscal VARCHAR(10) DEFAULT '616'`); }catch(e){}
    try{ await _caSql(`ALTER TABLE centro_apoyo ADD COLUMN IF NOT EXISTS uso_cfdi VARCHAR(10) DEFAULT 'S01'`); }catch(e){}
})();

// ── Load all centres ──────────────────────────────────────────
async function loadCentrosApoyo(){
    try{
        _caData=await _caSql("SELECT * FROM centro_apoyo ORDER BY creado_en DESC");
        // count linked notes per centro
        const noteCounts=await _caSql("SELECT centro_apoyo_id,COUNT(*)::int as cnt FROM venta WHERE centro_apoyo_id IS NOT NULL GROUP BY centro_apoyo_id");
        const noteMap={};noteCounts.forEach(r=>{noteMap[r.centro_apoyo_id]=r.cnt;});
        _caData.forEach(c=>{c._notas=noteMap[c.id]||0;});

        // ── Cargar resumen del Líder Especial "POR ASIGNAR" (#230 / 270a09e5-8250-44ea-82fa-b26dfc0553f0) ──
        try {
            const paRes = await _caSql(`
                SELECT COUNT(*)::int AS cnt, COALESCE(SUM(total),0) AS total_monto
                FROM venta
                WHERE cliente_id = '270a09e5-8250-44ea-82fa-b26dfc0553f0'
                  AND approved = 1
                  AND (producto_id IS NULL OR producto_id != 'calificacion-mes')
            `);
            if (paRes && paRes.length > 0 && paRes[0].cnt > 0) {
                _caData.unshift({
                    id: 'virtual_por_asignar',
                    _isVirtual: true,
                    _virtualLiderUuid: '270a09e5-8250-44ea-82fa-b26dfc0553f0',
                    lider_id: 230,
                    admin_id: null,
                    nombre: '🏷️ Centro Especial — Por Asignar',
                    _lider_nombre: 'Por Asignar (#230)',
                    _admin_nombre: 'Sistema Corporativo',
                    estado: 'por_asignar',
                    limite_credito: 0,
                    credito_usado: 0,
                    _notas: paRes[0].cnt,
                    _totalMonto: parseFloat(paRes[0].total_monto || 0),
                    moneda: 'MXN',
                    cedis_origen: '0'
                });
            }
        } catch(paErr) { console.warn('[Por Asignar Summary Error]', paErr.message); }

        // Resolver nombres de lider y admin para centros reales
        const registros=[..._caData.map(c=>c.lider_id),..._caData.map(c=>c.admin_id)].filter(Boolean).map(v=>String(v).replace(/'/g,"''"));
        if(registros.length){
            const sql=`SELECT registro::text as reg, nombre, COALESCE(ape_p,'') as ap FROM cliente WHERE registro::text IN ('${[...new Set(registros)].join("','")}')`;
            const clientes=await _caSql(sql);
            const nm={};
            clientes.forEach(r=>{nm[String(r.reg)]=r.nombre+' '+r.ap;});
            _caData.forEach(c=>{
                if(!c._isVirtual) {
                    c._lider_nombre=nm[String(c.lider_id)]||null;
                    c._admin_nombre=nm[String(c.admin_id)]||null;
                }
            });
        }
        renderCentrosKpis();
        renderCentrosTable();
    }catch(e){console.error('loadCentrosApoyo',e);}
}

function renderCentrosKpis(){
    const activos=_caData.filter(c=>!c._isVirtual && c.estado==='activo').length;
    const creditoTotal=_caData.filter(c=>!c._isVirtual).reduce((s,c)=>s+Number(c.credito_usado||0),0);
    const sobreLimite=_caData.filter(c=>{if(c._isVirtual) return false; const l=Number(c.limite_credito||0);return l>0&&(Number(c.credito_usado||0)/l)>=0.9;}).length;
    const totalNotas=_caData.reduce((s,c)=>s+(c._notas||0),0);
    document.getElementById('ca-kpi-activos').textContent=activos;
    document.getElementById('ca-kpi-credito').textContent='$'+creditoTotal.toLocaleString('es-MX',{minimumFractionDigits:2});
    document.getElementById('ca-kpi-alerta').textContent=sobreLimite;
    document.getElementById('ca-kpi-notas').textContent=totalNotas;
}

function renderCentrosTable(){
    const q=(document.getElementById('caSearch')?.value||'').toLowerCase();
    const est=document.getElementById('caFiltroEstado')?.value||'';
    let rows=_caData.filter(c=>{
        if(est&&c.estado!==est)return false;
        const liderTxt=(c._lider_nombre||c.lider_id||'').toString().toLowerCase();
        if(q&&!(c.nombre||'').toLowerCase().includes(q)&&!liderTxt.includes(q))return false;
        return true;
    });
    document.getElementById('ca-count').textContent=rows.length+' centros';
    const tb=document.getElementById('caTableBody');
    if(!rows.length){tb.innerHTML='<tr><td colspan="7" style="text-align:center;color:var(--text-dim);padding:2rem;">Sin resultados</td></tr>';return;}
    tb.innerHTML=rows.map(c=>{
        if(c._isVirtual) {
            return `<tr style="background:rgba(99,102,241,.08);border-left:4px solid #818cf8;">
                <td><strong>${c.nombre}</strong><div style="font-size:.7rem;color:#a5b4fc;">Notas de activación pendiente del usuario Por Asignar (#230)</div></td>
                <td>${c._lider_nombre}</td>
                <td><span style="color:var(--text-dim);font-size:.78rem;">Sistema</span></td>
                <td><span style="color:#a5b4fc;font-weight:700;font-size:.82rem;">⚡ ${_caMoneyFmt(c._totalMonto,c.moneda)} (Pago Adquirido)</span></td>
                <td style="text-align:center;"><span class="pill" style="background:rgba(99,102,241,.25);color:#a5b4fc;font-weight:600;">${c._notas} notas</span></td>
                <td><span class="badge" style="background:rgba(99,102,241,.2);color:#a5b4fc;border:1px solid rgba(99,102,241,.4);">🏷️ POR ASIGNAR</span></td>
                <td style="text-align:center;white-space:nowrap;">
                    <button class="btn btn-primary btn-sm" style="background:#6366f1;border:none;font-size:.78rem;" onclick="verDetalleCentro('virtual_por_asignar')" title="Ver Notas Por Asignar">⚡ Resolver Pendientes</button>
                </td>
            </tr>`;
        }

        const lim = Number(c.limite_credito||0);
        const balance = (c._balanceReal !== undefined) ? c._balanceReal : Number(c.credito_usado||0);
        const liderLabel = c._lider_nombre||('#'+c.lider_id)||'—';
        const adminLabel = c._admin_nombre||('#'+c.admin_id)||'—';

        let creditoCelda;
        if(balance < 0){
            const aFavor = Math.abs(balance);
            creditoCelda = `<span style="color:#22c55e;font-weight:700;font-size:.82rem;">✅ A favor: ${_caMoneyFmt(aFavor,c.moneda)}</span>`;
        } else {
            const pct = lim>0 ? Math.min(105, Math.round(balance/lim*100)) : 0;
            const barColor = pct>=90 ? '#ef4444' : pct>=70 ? '#f59e0b' : '#22c55e';
            const textColor = pct>=90 ? '#ef4444' : '';
            creditoCelda = `<div style="display:flex;align-items:center;gap:.5rem;">
                <div style="flex:1;background:rgba(255,255,255,.08);border-radius:99px;height:8px;min-width:60px;overflow:hidden;">
                    <div style="width:${Math.min(pct,100)}%;height:100%;background:${barColor};border-radius:99px;"></div>
                </div>
                <span style="font-size:.75rem;white-space:nowrap;color:${textColor};">${_caMoneyFmt(balance,c.moneda)} / ${_caMoneyFmt(lim,c.moneda)}</span>
            </div>`;
        }
        return `<tr>
            <td><strong>${c.nombre}</strong><div style="font-size:.7rem;color:var(--text-dim);">${c.moneda||'MXN'} · CEDIS ${c.cedis_origen||'0'}</div></td>
            <td>${liderLabel}</td>
            <td>${adminLabel}</td>
            <td>${creditoCelda}</td>
            <td style="text-align:center;">${c._notas||0}</td>
            <td>${_caEstadoBadge(c.estado)}</td>
            <td style="text-align:center;white-space:nowrap;">
                <button class="btn btn-outline btn-sm" onclick="verDetalleCentro(${c.id})" title="Ver detalle">👁</button>
                <button class="btn btn-outline btn-sm" onclick="abrirModalEditarCentro(${c.id})" title="Editar">✏️</button>
            </td>
        </tr>`;
    }).join('');
}

// ── CRUD Centro ───────────────────────────────────────────────
function abrirModalNuevoCentro(){
    document.getElementById('modalNuevoCentroTitulo').textContent='＋ Nuevo Centro de Apoyo';
    ['ca-nombre','ca-lider-search','ca-lider-id','ca-lider-selected','ca-admin-search','ca-admin-id','ca-admin-selected','ca-notas','ca-edit-id','ca-rfc','ca-razon','ca-cp'].forEach(id=>{const e=document.getElementById(id);if(e)e.value?e.value='':e.textContent='';});
    document.getElementById('ca-limite').value='';
    document.getElementById('ca-moneda').value='MXN';
    _caLoadCedisSelect();
    document.getElementById('modalNuevoCentro').style.display='flex';
}
function cerrarModalNuevoCentro(){document.getElementById('modalNuevoCentro').style.display='none';}

async function abrirModalEditarCentro(id){
    const c=_caData.find(x=>x.id===id);if(!c)return;
    if(document.getElementById('modalNuevoCentroTitulo')) document.getElementById('modalNuevoCentroTitulo').textContent='✏️ Editar Centro';
    if(document.getElementById('ca-edit-id')) document.getElementById('ca-edit-id').value=id;
    if(document.getElementById('ca-nombre')) document.getElementById('ca-nombre').value=c.nombre||'';
    if(document.getElementById('ca-lider-search')) document.getElementById('ca-lider-search').value='';
    if(document.getElementById('ca-lider-id')) document.getElementById('ca-lider-id').value=c.lider_id||'';
    if(document.getElementById('ca-lider-selected')) document.getElementById('ca-lider-selected').textContent='Líder: '+c.lider_id;
    if(document.getElementById('ca-admin-search')) document.getElementById('ca-admin-search').value='';
    if(document.getElementById('ca-admin-id')) document.getElementById('ca-admin-id').value=c.admin_id||'';
    if(document.getElementById('ca-admin-selected')) document.getElementById('ca-admin-selected').textContent=c.admin_id?'Admin: '+c.admin_id:'';
    if(document.getElementById('ca-limite')) document.getElementById('ca-limite').value=c.limite_credito||'';
    if(document.getElementById('ca-moneda')) document.getElementById('ca-moneda').value=c.moneda||'MXN';
    if(document.getElementById('ca-notas')) document.getElementById('ca-notas').value=c.notas||'';
    if(document.getElementById('ca-rfc')) document.getElementById('ca-rfc').value=c.rfc||'';
    if(document.getElementById('ca-razon')) document.getElementById('ca-razon').value=c.razon_social||'';
    if(document.getElementById('ca-cp')) document.getElementById('ca-cp').value=c.codigo_postal||'';
    if(document.getElementById('ca-regimen')) document.getElementById('ca-regimen').value=c.regimen_fiscal||'616';
    if(document.getElementById('ca-uso-cfdi')) document.getElementById('ca-uso-cfdi').value=c.uso_cfdi||'S01';
    _caLoadCedisSelect();
    setTimeout(()=>{if(document.getElementById('ca-cedis')) document.getElementById('ca-cedis').value=c.cedis_origen||'0';},100);
    if(document.getElementById('modalNuevoCentro')) document.getElementById('modalNuevoCentro').style.display='flex';
}

async function guardarCentro(){
    const nombre=document.getElementById('ca-nombre')?.value?.trim()||'';
    let liderId=document.getElementById('ca-lider-id')?.value?.trim()||'';
    
    // Auto-resolución de ID del líder si está seleccionado visualmente pero ca-lider-id no se llenó
    if (!liderId) {
        const selText = document.getElementById('ca-lider-selected')?.textContent || '';
        const matchReg = selText.match(/\((\d+)\)/);
        if (matchReg) {
            liderId = matchReg[1];
            if (document.getElementById('ca-lider-id')) document.getElementById('ca-lider-id').value = liderId;
        }
    }

    if(!nombre||!liderId) return BO_AUTH.showAlert('Nombre y líder son obligatorios','warning');
    const editId=document.getElementById('ca-edit-id')?.value||'';
    const esc=v=>(v===null||v===undefined)?'NULL':"'"+String(v).replace(/'/g,"''")+"'";
    const adminId=document.getElementById('ca-admin-id')?.value?.trim()||null;
    const cedis=document.getElementById('ca-cedis')?.value||'0';
    const limite=Number(document.getElementById('ca-limite')?.value)||0;
    const moneda=document.getElementById('ca-moneda')?.value||'MXN';
    const notas=document.getElementById('ca-notas')?.value?.trim()||null;
    const rfc=document.getElementById('ca-rfc')?.value?.trim()||null;
    const razon=document.getElementById('ca-razon')?.value?.trim()||null;
    const cp=document.getElementById('ca-cp')?.value?.trim()||null;
    const regimen=document.getElementById('ca-regimen')?.value||'616';
    const usoCfdi=document.getElementById('ca-uso-cfdi')?.value||'S01';
    try{
        if(editId){
            await _caSql(`UPDATE centro_apoyo SET nombre=${esc(nombre)},lider_id=${esc(liderId)},admin_id=${esc(adminId)},cedis_origen=${esc(cedis)},limite_credito=${limite},moneda=${esc(moneda)},notas=${esc(notas)},rfc=${esc(rfc)},razon_social=${esc(razon)},codigo_postal=${esc(cp)},regimen_fiscal=${esc(regimen)},uso_cfdi=${esc(usoCfdi)},actualizado_en=NOW() WHERE id=${editId}`);
            BO_AUTH.showAlert('Centro actualizado ✓','success');
        }else{
            await _caSql(`INSERT INTO centro_apoyo(nombre,lider_id,admin_id,cedis_origen,limite_credito,moneda,notas,rfc,razon_social,codigo_postal,regimen_fiscal,uso_cfdi) VALUES(${esc(nombre)},${esc(liderId)},${esc(adminId)},${esc(cedis)},${limite},${esc(moneda)},${esc(notas)},${esc(rfc)},${esc(razon)},${esc(cp)},${esc(regimen)},${esc(usoCfdi)})`);
            BO_AUTH.showAlert('Centro creado ✓','success');
        }
        cerrarModalNuevoCentro();
        await loadCentrosApoyo();
    }catch(e){
        console.error('Error al guardar centro:', e);
        BO_AUTH.showAlert('Error al guardar: ' + (e.message || e), 'error');
    }
}

// ── Autocomplete lider/admin ──────────────────────────────────
let _caLiderTimer=null;
let _caAdminTimer=null;
function _sqlEsc(v){return String(v).replace(/'/g,"''");}

async function buscarLiderParaCentro(q){
    clearTimeout(_caLiderTimer);
    if(q.length<2){document.getElementById('ca-lider-results').style.display='none';return;}
    _caLiderTimer=setTimeout(async()=>{
        try{
            const safe=_sqlEsc(q);
            const rows=await _caSql(`SELECT id, nombre, COALESCE(ape_p,'') AS apellido, registro FROM cliente WHERE (COALESCE(nombre,'')||' '||COALESCE(ape_p,'')) ILIKE '%${safe}%' OR registro::text ILIKE '%${safe}%' OR id::text='${safe}' LIMIT 8`);
            const box=document.getElementById('ca-lider-results');
            if(!rows.length){box.style.display='none';return;}
            box.style.display='block';
            box.innerHTML=rows.map(r=>`<div style="padding:.5rem .75rem;cursor:pointer;font-size:.82rem;border-bottom:1px solid rgba(255,255,255,.05);" onmouseover="this.style.background='rgba(99,102,241,.15)'" onmouseout="this.style.background=''" onclick="document.getElementById('ca-lider-id').value='${r.registro||r.id}';document.getElementById('ca-lider-selected').textContent='✓ ${r.nombre} ${r.apellido} (${r.registro||r.id})';document.getElementById('ca-lider-results').style.display='none';document.getElementById('ca-lider-search').value='';">${r.nombre} ${r.apellido} <span style="color:var(--text-dim);">#${r.registro||r.id}</span></div>`).join('');
        }catch(e){console.error('buscarLider',e);}
    },300);
}
async function buscarAdminParaCentro(q){
    clearTimeout(_caAdminTimer);
    if(q.length<2){document.getElementById('ca-admin-results').style.display='none';return;}
    _caAdminTimer=setTimeout(async()=>{
        try{
            const safe=_sqlEsc(q);
            const rows=await _caSql(`SELECT c.id, c.nombre, COALESCE(c.ape_p,'') AS apellido, c.registro, r.rol AS rol_nombre FROM cliente c LEFT JOIN rol r ON r.id = c.rol_id WHERE LOWER(r.rol) IN ('admin','master','administrador') AND ((COALESCE(c.nombre,'')||' '||COALESCE(c.ape_p,'')) ILIKE '%${safe}%' OR c.registro::text ILIKE '%${safe}%') LIMIT 6`);
            const box=document.getElementById('ca-admin-results');
            if(!rows.length){box.style.display='none';return;}
            box.style.display='block';
            box.innerHTML=rows.map(r=>`<div style="padding:.5rem .75rem;cursor:pointer;font-size:.82rem;border-bottom:1px solid rgba(255,255,255,.05);" onmouseover="this.style.background='rgba(99,102,241,.15)'" onmouseout="this.style.background=''" onclick="document.getElementById('ca-admin-id').value='${r.registro||r.id}';document.getElementById('ca-admin-selected').textContent='✓ ${r.nombre} ${r.apellido}';document.getElementById('ca-admin-results').style.display='none';document.getElementById('ca-admin-search').value='';">${r.nombre} ${r.apellido} <span style="color:var(--text-dim);">${r.rol_nombre}</span></div>`).join('');
        }catch(e){console.error('buscarAdmin',e);}
    },300);
}

function _caLoadCedisSelect(){
    const sel=document.getElementById('ca-cedis');
    if(!sel)return;
    sel.innerHTML='<option value="0">🏢 Inventario General (Matriz)</option>';
    if(typeof CEDIS_DEF!=='undefined'){
        CEDIS_DEF.filter(c=>c.id!==0).forEach(c=>{sel.innerHTML+=`<option value="${c.id}">${c.icono||'📦'} ${c.nombre}</option>`;});
    }
}

// ── Modal Absorber Notas Por Asignar ──────────────────────────────
let _caUnlinkedNotas = [];
let _caSelectedNotas = new Set();

async function abrirModalAbsorberNotas(){
    const modal = document.getElementById('modalAbsorberNotas');
    if(!modal) return;

    const select = document.getElementById('caAbsorberCentroSelect');
    if(select) {
        select.innerHTML = '<option value="">-- Selecciona Centro Destino --</option>' +
            _caData.map(c => `<option value="${c.id}">${c.nombre} (Líder #${c.lider_id})</option>`).join('');
    }

    _caSelectedNotas.clear();
    const checkAll = document.getElementById('caAbsorberCheckAll');
    if(checkAll) checkAll.checked = false;
    
    updateAbsorberResumen();
    modal.style.display = 'flex';
    await cargarNotasAbsorber();
}

function cerrarModalAbsorberNotas(){
    const modal = document.getElementById('modalAbsorberNotas');
    if(modal) modal.style.display = 'none';
}

async function cargarNotasAbsorber(){
    const tb = document.getElementById('caAbsorberTableBody');
    if(!tb) return;
    tb.innerHTML = '<tr><td colspan="5" style="text-align:center;color:var(--text-dim);padding:1.5rem;">⏳ Cargando notas sin vincular...</td></tr>';
    
    try {
        _caUnlinkedNotas = await _caSql(`
            SELECT v.id, v.fecha_venta, v.total, v.approved, v.cliente_id,
                   COALESCE(c.nombre || ' ' || COALESCE(c.ape_p,''), 'Público General') AS cliente_nombre,
                   c.registro AS cliente_registro
            FROM venta v
            LEFT JOIN cliente c ON c.id = v.cliente_id
            WHERE v.centro_apoyo_id IS NULL AND v.approved = 1 AND (v.producto_id IS NULL OR v.producto_id != 'calificacion-mes')
            ORDER BY v.fecha_venta DESC
            LIMIT 200
        `);
        renderNotasAbsorberTable();
    } catch(e) {
        tb.innerHTML = '<tr><td colspan="5" style="color:#ef4444;text-align:center;padding:1.5rem;">Error: ' + e.message + '</td></tr>';
    }
}

function renderNotasAbsorberTable(){
    const q = (document.getElementById('caAbsorberSearch')?.value || '').toLowerCase();
    const tb = document.getElementById('caAbsorberTableBody');
    if(!tb) return;

    const filtered = _caUnlinkedNotas.filter(n => {
        if(!q) return true;
        const text = `${n.id} ${n.cliente_nombre} ${n.cliente_registro}`.toLowerCase();
        return text.includes(q);
    });

    if(!filtered.length){
        tb.innerHTML = '<tr><td colspan="5" style="text-align:center;color:var(--text-dim);padding:1.5rem;">Sin notas no vinculadas que coincidan</td></tr>';
        return;
    }

    tb.innerHTML = filtered.map(n => {
        const isChecked = _caSelectedNotas.has(n.id);
        const fecha = n.fecha_venta ? new Date(n.fecha_venta).toLocaleDateString('es-MX') : '—';
        return `<tr>
            <td><input type="checkbox" value="${n.id}" ${isChecked ? 'checked' : ''} onchange="toggleSelectNotaAbsorber('${n.id}', this.checked)"></td>
            <td><span style="font-family:monospace;font-size:.78rem;">${(n.id||'').substring(0,14)}</span></td>
            <td>${fecha}</td>
            <td>${n.cliente_nombre} <span style="font-size:.72rem;color:var(--text-dim);">(#${n.cliente_registro||'—'})</span></td>
            <td style="text-align:right;">${_caMoneyFmt(n.total, 'MXN')}</td>
        </tr>`;
    }).join('');
}

function toggleSelectNotaAbsorber(id, checked){
    if(checked) _caSelectedNotas.add(id);
    else _caSelectedNotas.delete(id);
    updateAbsorberResumen();
}

function toggleSelectAllAbsorber(checkAllEl){
    const isChecked = checkAllEl.checked;
    const q = (document.getElementById('caAbsorberSearch')?.value || '').toLowerCase();
    const filtered = _caUnlinkedNotas.filter(n => {
        if(!q) return true;
        return `${n.id} ${n.cliente_nombre} ${n.cliente_registro}`.toLowerCase().includes(q);
    });
    filtered.forEach(n => {
        if(isChecked) _caSelectedNotas.add(n.id);
        else _caSelectedNotas.delete(n.id);
    });
    renderNotasAbsorberTable();
    updateAbsorberResumen();
}

function updateAbsorberResumen(){
    const resEl = document.getElementById('caAbsorberResumen');
    const btn = document.getElementById('caBtnEjecutarAbsorcion');
    const totalMonto = _caUnlinkedNotas.filter(n => _caSelectedNotas.has(n.id)).reduce((s, n) => s + parseFloat(n.total || 0), 0);
    const count = _caSelectedNotas.size;

    if(resEl) resEl.textContent = `${count} notas seleccionadas (${_caMoneyFmt(totalMonto, 'MXN')} respaldo)`;
    if(btn) btn.disabled = (count === 0);
}

async function ejecutarAbsorcionNotas(){
    const centroId = document.getElementById('caAbsorberCentroSelect')?.value;
    if(!centroId) {
        BO_AUTH.showAlert('⚠️ Por favor selecciona el Centro de Apoyo destino.', 'warning');
        return;
    }
    if(_caSelectedNotas.size === 0) return;

    const ids = Array.from(_caSelectedNotas);
    const centro = _caData.find(c => String(c.id) === String(centroId));
    const centroNombre = centro ? centro.nombre : `ID #${centroId}`;

    if(!confirm(`⚡ ¿Confirmas vincular ${ids.length} notas al centro "${centroNombre}" y generar la activación del mes ($0 Crédito deudor)?`)) return;

    try {
        BO_AUTH.showAlert('⏳ Vinculando notas y procesando activación...', 'info');
        const idsSql = ids.map(id => `'${id}'`).join(',');

        // 1. Vincular notas al centro de apoyo seleccionado
        await _caSql(`UPDATE venta SET centro_apoyo_id = ${centroId} WHERE id IN (${idsSql})`);

        // 2. Obtener líderes únicos de estas notas y generar activación si aplica
        const lideresRes = await _caSql(`SELECT DISTINCT cliente_id FROM venta WHERE id IN (${idsSql}) AND cliente_id IS NOT NULL`);
        const now = new Date();
        const mesStr = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');

        for (const l of (lideresRes || [])) {
            const lid = l.cliente_id;
            const actCheck = await _caSql(`
                SELECT id FROM venta 
                WHERE cliente_id = '${lid}' 
                  AND producto_id = 'calificacion-mes'
                  AND TO_CHAR(fecha_venta, 'YYYY-MM') = '${mesStr}'
                  AND approved = 1
            `);
            if(!actCheck || actCheck.length === 0) {
                const newId = 'ACT-PA-' + Math.random().toString(36).substring(2, 10).toUpperCase();
                await _caSql(`
                    INSERT INTO venta (id, cliente_id, total, cantidad, approved, fecha_venta, producto_id, comentario, centro_apoyo_id)
                    VALUES ('${newId}', '${lid}', 0.00, 1, 1, NOW(), 'calificacion-mes', 'ACTIVACIÓN PAGO ADQUIRIDO || CENTRO ${centroId}', ${centroId})
                `);
            }
        }

        BO_AUTH.showAlert(`✅ ${ids.length} notas vinculadas a ${centroNombre} exitosamente ($0 Crédito).`, 'success');
        cerrarModalAbsorberNotas();
        await loadCentrosApoyo();
    } catch(e) {
        console.error('ejecutarAbsorcionNotas error:', e);
        BO_AUTH.showAlert('❌ Error al vincular notas: ' + e.message, 'danger');
    }
}
